import type { TherapiesPreset } from "@/types/therapies-presets"
import type { Therapy } from "@/types/therapy"
import { API_ROOT, HttpClient } from "@/api/httpClient"

export type TherapyPayload = Omit<Therapy, "id" | "created_at" | "updated_at">

export interface TherapyPresetPayload {
	name: string
	therapies: TherapyPayload[]
}

export default {
	list() {
		return HttpClient.get<TherapiesPreset[]>(`${API_ROOT}/doctors/me/therapies-presets`)
	},
	suggestions() {
		return HttpClient.get<Therapy[]>(`${API_ROOT}/doctors/me/therapies-presets/suggestions`)
	},
	create(payload: TherapyPresetPayload) {
		return HttpClient.post<TherapiesPreset>(`${API_ROOT}/doctors/me/therapies-presets`, payload)
	},
	update(presetId: number, payload: TherapyPresetPayload) {
		return HttpClient.put(`${API_ROOT}/doctors/me/therapies-presets/${presetId}`, payload)
	},
	delete(presetId: number) {
		return HttpClient.delete(`${API_ROOT}/doctors/me/therapies-presets/${presetId}`)
	}
}
